<template>
    <div class="row report-row">
        <div class="col-md-12">
            <div v-if="loading" class="col-12 mt-5 mb-5" v-loading="true"></div>

            <card v-else >
                <template slot="header">
                    <div class="d-flex justify-content-between">
                        Mass Texts Log
                        <el-button
                            v-if="user.admin || (user.adminRoles && user.adminRoles[user._id] && user.adminRoles[user._id].sendMassEmails) || (user.roles && user.roles[eventId] && user.roles[eventId].sendMassEmails)"
                            class="btn btn-primary"
                            :loading="downloading"
                            @click="downloadMassTextLog()">
                                Download
                                <fa icon="download"/>
                        </el-button>
                    </div>
                </template>
                <table class="table table-responsive custom table-striped text-center scrollable-table report-table">
                    <thead>
                        <tr>
                            <th style="min-width: 100px">
                                Confirmation Number
                                <el-input
                                    v-model="filters.confirmationNumber"
                                    @keyup.native="filterLogs(true)"/>
                            </th>
                            <th style="min-width: 100px">
                                Timestamp
                            </th>
                            <th style="min-width: 100px">
                                Registrant Phone
                                <el-input
                                    v-model="filters.registrantPhone"
                                    @keyup.native="filterLogs(true)"/>
                            </th>
                            <th style="min-width: 100px">
                                Registrant First Name
                                <el-input
                                    v-model="filters.registrantFirstName"
                                    @keyup.native="filterLogs(true)"/>
                            </th>
                            <th style="min-width: 100px">
                                Registrant Last Name
                                <el-input
                                    v-model="filters.registrantLastName"
                                    @keyup.native="filterLogs(true)"/>
                            </th>
                            <th style="min-width: 100px">
                                Creator
                            </th>
                            <th style="min-width: 100px">
                                Message
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr
                            v-for="log in massTextLogs"
                            :key="`logger-${log._id}`">
                                <td>{{ log.confirmationNumber }}</td>
                                <td>{{ log.createdAt | formatDate }}</td>
                                <td>{{ log.registrantPhone }}</td>
                                <td>{{ log.registrantFirstName }}</td>
                                <td>{{ log.registrantLastName }}</td>
                                <td>{{ log.creator ? log.creator.email : '' }}</td>
                                <td>
                                    <span @click="viewMessage(log.message)" style="text-decoration: underline; cursor: pointer;">View Message</span>
                                </td>
                        </tr>
                    </tbody>
                </table>
                <div v-if="total" class="row">
                    <div class="col-12 d-flex justify-content-end">
                        <el-pagination
                            background
                            layout="total, sizes, prev, pager, next, jumper"
                            @size-change="getRegistrations"
                            @current-change="getRegistrations"
                            :current-page.sync="page"
                            :total="total"
                            :page-size.sync="perPage"
                            :page-sizes="[50, 100, 200, 400, 500, 1000]">
                        </el-pagination>
                    </div>
                </div>
            </card>
        </div>

        <el-dialog 
        :close-on-click-modal="false"
        :visible.sync="showMessage">
            <div class="ql-editor" v-html="message"></div>
        </el-dialog>
    </div>
</template>
<style>
.report-table {
       width: initial;
    overflow: visible !important;
}
.report-row .card .card-body {
    height:80vh;
    overflow-x: auto;
    overflow-y: auto;
}
</style>
<script>
import http from '../http.js'
import moment from 'moment'
import download from 'downloadjs'
import _ from 'lodash'
import { mapState } from 'vuex'

export default {
    data () {
        return {
            loading: true,
            downloading: false,
            massTextLogs:[],
            total: 0,
            perPage: 50,
            page: 1,
            filters: {
                confirmationNumber: '',
                registrantFirstName: '',
                registrantLastName: '',
                registrantEmail: '',
            },
            eventId: null,
            showMessage: false,
            message: ""
        }
    },
    computed: {
        ...mapState([
            'user',
        ])
    },
    mounted () {
        this.eventId = this.$route.params.eventId
        this.getMassTextLogs()
        
    },
    methods: {
        viewMessage(message){
            this.message = message;
            this.showMessage = true
        },
        getMassTextLogs: async function () {
            this.loading = true
            try {
                const response = await http.get(`/api/mass-text-logs?event=${this.eventId}`)
                this.massTextLogs = response.data.massTextLogs
                // this.total = this.massTextLogs.length
                this.allLogs = response.data.massTextLog
                this.filterLogs()
            } catch (e) {
                this.$store.dispatch('handleErrors', e)
                console.log('error getting data in massTextLogs')
            }
            this.loading = false
        },
        filterLogs: function (debounce = false) {
            const filter = () => {
                this.massTextLogs = this.allLogs.filter(log => {
                    
                    if (this.filters.confirmationNumber && log.confirmationNumber !== this.filters.confirmationNumber) {
                        return false
                    }
                    
                    if(this.filters.registrantFirstName && log.registrantFirstName !== this.filters.registrantFirstName){  
                        return false;
                    }
                    if(this.filters.registrantLastName && log.registrantLastName !== this.filters.registrantLastName){  
                        return false;
                    }
                    if(this.filters.registrantEmail && log.registrantEmail !== this.filters.registrantEmail){
                        return false;
                    }
   
                    return true
                })
            }

            if (debounce) {
                let delay = _.debounce(() => {
                    filter()
                }, 300)
                delay()
            } else {
                filter()
            }
        },
        downloadMassTextLog: async function () {
            this.downloading = true
            try {
                const response = await http.post('/api/download-mass-text-logs',{
                    eventId: this.eventId
                },{
                    responseType: 'arraybuffer'
                })
                download(response.data, 'mass-email-logs.xlsx', '	application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')
            } catch (e) {
                this.$store.dispatch('handleErrors', e)
                console.log('error downloading list')
            }
            this.downloading = false
        },
    },
    filters: {
        formatDate: (value) => moment(value).format('YYYY-MM-DD HH:mm:ss'),
        // deposit: (registration) => {
        //     let deposit = parseInt(registration.total) - parseInt(registration.paid)

        //     if (deposit < 0) {
        //         deposit = 0
        //     }
            
        //     return deposit
        // },
        // avlRegistrantCount: (value)=>{
        //     if(value.type.groupCount){
        //         let hasRegistrant = Object.values(value.type.groupCount).reduce((total,item)=>parseInt(total)+parseInt(item))
        //         return (hasRegistrant+1) - (value.registrants.length + 1 )
        //     }else{
        //         return '';
        //     }
        // }
    }
}
</script>